import { mapState, mapGetters, mapActions } from 'vuex'

import BaseModal from '../BaseModal'

import MainButton from '../atoms/MainButton'
import MainInput from '../atoms/MainInput'
import MainCheckbox from '../atoms/MainCheckbox'

const STATIC_OTHER_OPTION = { value: 'other', label: 'Свій варіант' }

export default {
	name		: 'ModalPointA',
	components	: {
		BaseModal,
		MainButton,
		MainInput,
		MainCheckbox
	},
	props		: {
		isVisible: {
			type	: Boolean,
			default	: false
		},
		courseSlug: {
			type	: String,
			default	: ''
		},
		packageId: {
			type	: [Number, String],
			default	: null
		},
		courseId: {
			type	: [Number, String],
			default	: null
		},
		nextRoute: {
			type	: Object,
			default	: null
		},
		pointAClosedCount: {
			type	: Number,
			default	: 0
		},
		suppressNavigation: {
			type	: Boolean,
			default	: false
		}
	},
	data() {
		return {
			form				: {
				firstName			: '',
				lastName			: '',
				birthDate			: '',
				skillLevel			: 1,
				expectations		: [],
				expectationOther	: ''
			},
			errors				: {},
			isSubmitting		: false,
			isLoadingOptions	: false,
		}
	},
	computed	: {
		...mapState(['user']),
		...mapGetters('pointAB', ['pointACompleted', 'expectationOptions']),
		pointAModalCanClose() {
			const n = Number(this.pointAClosedCount)
			
			return (Number.isFinite(n) ? n : 0) < 5
		},
		modalTitle() {
			return 'Розкажіть про себе перед початком курсу'
		},
		todayDate() {
			const today = new Date()
			return today.toISOString().split('T')[0]
		},
		isFormValid() {
			return this.form.firstName.trim() !== '' &&
			this.form.lastName.trim() !== '' &&
			this.form.birthDate !== '' &&
			this.form.skillLevel >= 1 &&
			this.form.expectations.length > 0
		},
		expectationOptionsList() {
			const dynamic = (this.expectationOptions || []).filter(
				option => option.value !== STATIC_OTHER_OPTION.value
			)

			return [...dynamic, STATIC_OTHER_OPTION]
		},
		expectationsLang() {
			if (this.$store.getters.currentLanguage && this.$store.getters.currentLanguage.translationKey) {
				return this.$store.getters.currentLanguage.translationKey
			}

			return this.$route.params.lang || 'uk'
		},
	},
	watch: {
		isVisible: {
			immediate: true,
			handler(visible) {
				if (visible) {
					this.loadExpectationOptions()
				}
			},
		},
	},
	methods		: {
		...mapActions('pointAB', {
			savePointA				: 'SAVE_POINT_A',
			saveAbFormClosure		: 'SAVE_AB_FORM_CLOSURE',
			fetchExpectationOptions	: 'GET_EXPECTATION_OPTIONS',
		}),
		async loadExpectationOptions() {
			if (this.isLoadingOptions) {
				return
			}

			this.isLoadingOptions = true

			try {
				await this.fetchExpectationOptions({ lang: this.expectationsLang })
			} catch (e) {
				// fallback: only static "other" from store on error
			} finally {
				this.isLoadingOptions = false
			}
		},
		shouldNavigateAfterPointA() {
			if (this.suppressNavigation) {
				return false
			}
			
			return !!(this.courseSlug || (this.nextRoute && this.nextRoute.name))
		},
		navigateToPointATarget() {
			this.$router.push(this.$localize(this.resolveNextRoute()))
		},
		resolveNextRoute() {
			if (this.nextRoute && this.nextRoute.name) {
				return this.nextRoute
			}
			
			return {
				name	: 'courses-main',
				params	: { item: this.courseSlug },
			}
		},
		recordModalPointADismissed() {
			console.log('[ModalPointA] modal dismissed (close control)', {
				courseSlug	: this.courseSlug,
				courseId	: this.courseId,
				packageId	: this.packageId,
				targetRoute	: this.shouldNavigateAfterPointA() ? this.resolveNextRoute() : null,
			})
		},
		async handleCloseAttempt() {
			this.recordModalPointADismissed()
			
			if (this.courseId != null && this.packageId != null) {
				try {
					await this.saveAbFormClosure({
						courseId	: this.courseId,
						packageId	: this.packageId,
						formType	: 'A',
					})
				} catch (e) {
					// помилка вже в https / store
				}
			}
			
			if (this.shouldNavigateAfterPointA()) {
				this.navigateToPointATarget()
			}
			
			this.$emit('close')
		},
		goToCourse() {
			if (this.shouldNavigateAfterPointA()) {
				this.navigateToPointATarget()
			}
			
			this.$emit('close')
		},
		toggleExpectation(value) {
			const index = this.form.expectations.indexOf(value)
			
			if (index > -1) {
				this.form.expectations.splice(index, 1)
			} else {
				this.form.expectations.push(value)
			}
		},
		validate() {
			this.errors = {}
			
			if (!this.form.firstName.trim()) {
				this.errors.firstName = 'Введіть ім\'я'
			}
			
			if (!this.form.lastName.trim()) {
				this.errors.lastName = 'Введіть прізвище'
			}
			
			// Валідація дати народження
			if (!this.form.birthDate) {
				this.errors.birthDate = 'Дата народження обов\'язкова для заповнення'
			} else {
				const birthDate = new Date(this.form.birthDate)
				const today = new Date()
				const minDate = new Date('1900-01-01')
				
				if (birthDate > today) {
					this.errors.birthDate = 'Будь ласка, введіть реальну дату народження'
				} else if (birthDate < minDate) {
					this.errors.birthDate = 'Перевірте правильність введеної дати'
				}
			}
			
			if (this.form.expectations.length === 0) {
				this.errors.expectations = 'Оберіть хоча б одне очікування'
			}
			
			return Object.keys(this.errors).length === 0
		},
		async handleSubmit() {
			if (!this.validate()) return
			
			if (this.courseId == null || this.packageId == null) return
			
			this.isSubmitting = true
			
			try {
				this.$store.commit('pointAB/SET_POINT_A_DATA', this.form)
				
				await this.savePointA({
					courseId	: this.courseId,
					packageId	: this.packageId,
				})
				
				this.$emit('completed')
				
				if (this.shouldNavigateAfterPointA()) {
					this.navigateToPointATarget()
				}
			} catch (e) {
				// помилка вже в store pointAB / https
			} finally {
				this.isSubmitting = false
			}
		}
	},
}
